<template>
  <pt-customer-table class="pt-system-customer-table__withData" ref="table" :tableLabels="tableLabels" :tableData="tableData"
   @getTableData="getTableData" :totalNumber="totalNumber" :isOutside="isOutside" :showRadio="showRadio" v-on="$listeners" :selectedKeys="selectedKeys">
      <slot/>
  </pt-customer-table>
</template>

<script>
import PtCustomerTable from './index'
export default {
  name: 'pt-customer-table__withData',
  components: {
    'pt-customer-table': PtCustomerTable
  },
  props: {
    tableLabels: {
      type: Array,
      default: function () {
        return []
      }
    },
    pageSize: {
      type: Number,
      default: 10
    },
    paramsData: {
      type: Object,
      default: function () {
        return {}
      }
    },
    isFromRouter: {
      type: Boolean,
      default: false
    },
    showRadio: {
      type: Boolean,
      default: false
    },
    selectedKeys: {
      type: String,
      default: ''
    },
  },
  computed: {
    page () {
      return this.$refs.table.page
    }
  },
  data () {
    return {
      tableData: [],
      totalNumber: 0,
      isOutside: false
    }
  },
  watch: {
    paramsData: {
      handler: function (val) {
        if (this.isFromRouter) {
          this.isOutside = true
          this.getTableData(this.page)
        } else {
          this.resetPage()
        }
      }
    }
  },
  methods: {
    resetPage () {
      this.$refs.table.resetPage()
    },
    getTableData (page, next) {
      let data = {
        example:{
          ...this.paramsData,
        },
        pageable: {
          page: page,
          size: this.pageSize
        }
      }
      this.$store.dispatch('getOrganizationsList', data).then(res => {
        this.tableData = res.data
        this.totalNumber = res.totalNumber
        if (next) {
          next(res.data)
        }
      }).catch(err => {
        this.$refs.table.showReTry()
        this.$message.error(err || '获取客户列表失败')
      })
    },
    reload (params = {}) {
      // this.currentParams = params
      this.$refs.table.reload()
    }
  }
}
</script>
